import React from 'react';
import BillsList from './BillsList';

const Bills = () => {
  return <BillsList />;
};

export default Bills;
